<template>
  <div class="card-box">
    <h4 class="title">{{ title }}</h4>
    <slot name="content">
      <p class="tip">暂无数据</p>
    </slot>
    <slot name="foot">

    </slot>
  </div>
</template>
<script>
  export default {
    props: {
      title: String,
    }
  }
</script>
<style lang="scss" scoped>
  @import "../styles/stylefunc";
  .card-box {
    width: auto;
    border: solid 1px #D6D6D6;
    box-shadow: 0 0px 10px #D6D6D6;
    text-align: center;
    .title {
      padding: 15px;
      background-color: #000000;
      color: white;
      font-size: 16px;
    }
    .tip {
      padding: 20px 0;
      font-size: 14px;
      color: #aaaaaa;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Card.vue